/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type AccountNavContent_viewer$ref = any;
export type AccountNavContent_viewer = {
    readonly isMessageCenterEnabled: boolean | null;
    readonly " $refType": AccountNavContent_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "AccountNavContent_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": "isMessageCenterEnabled",
            "name": "isEnabledByLocale",
            "args": [
                {
                    "kind": "Literal",
                    "name": "featureName",
                    "value": "MESSAGE_CENTER"
                }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"MESSAGE_CENTER\")"
        }
    ]
} as any);
(node as any).hash = 'd41778817c1cf35959f2bd8b8a5e5255';
export default node;
